// extracted by mini-css-extract-plugin
export var Container = "CategoryPage-module--Container--3vWKe";
export var CategoryHeader = "CategoryPage-module--CategoryHeader--2h7Yg";
export var CategoriesContainer = "CategoryPage-module--CategoriesContainer--2Izrc";
export var RadioContainer = "CategoryPage-module--RadioContainer--3ydvu";